const ComponentStateEnum = {
  'LESS': 1,
  'MORE': 2,
}

export default ComponentStateEnum;
